// ----------------------Project List-----------------
export const ProjectList = [
  {
    img: "/images/fashion_club.png",
    title: "Fashion Club ",
    description:
      "Fashion club is An Ecommerce website that deals in luxury fashion accessories like Clothing, Shoes, Bags, Accessories, Jewelry etc.",

    tech_stack: "React, Redux, Chakra-ui, Node.js, Express.js, MongoDB",
    github_url: "https://github.com/TabrezAlam98/Fashion-Club",
    demo_url: "https://fashion-club-ms.netlify.app/",
  },
  {
    img: "/images/fitmeals.png",
    title: "Fitmeals Clone",
    description:
      "A web application especially created for Food Delivery , Healthy Food,Fitness Diet, Fitness meal.",

    tech_stack: " CSS, Javascript, React, Redux",
    github_url: "https://github.com/Arfeen98/FitMealsCLone",
    demo_url: "https://flourishing-brigadeiros-066ec5.netlify.app/",
  },
  {
    img: "/images/shoppers stop.png",
    title: "Shoppers Stop Clone",
    description:
      "A Shoppers Stop web application created for buying clothes, handbags , shoes,jewellery ,  cosmetics , health and beauty products",

    tech_stack: "Html, Css, Javascript",
    github_url: "https://github.com/mshakir082/Shoppers_Stop-Clone",
    demo_url: "https://steady-bavarois-32dc0a.netlify.app/",
  },

  {
    img: "/images/form_buddy.png",
    title: "Form Buddy ",
    description:
      "Farm-Buddy is a online pharmacy & medical stores offering pharmaceutical and healthcare products across various categories .You can an order on our website/app by just few clicks.",

      tech_stack: "React, Redux, Chakra-ui, Node.js, Express.js, MongoDB",
    github_url: "https://github.com/TabrezAlam98/Farm-Buddy.com",
    demo_url: "https://pharmbuddy.vercel.app/",
  },
];

// ----------------------Skills-----------------

export const stackList = [
  {
    img: "https://cdn-icons-png.flaticon.com/128/174/174854.png",
    name: "HTML",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/128/5968/5968242.png",
    name: "CSS",
  },
  {
    img: "https://cdn-icons-png.flaticon.com/128/5968/5968292.png",
    name: "JavaScript",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original.svg",
    name: "NodeJs",
  },
  {
    img: "https://img.icons8.com/color/48/000000/react-native.png",
    name: "React",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
    name: "Redux",
  },

  {
    img: "https://cdn-icons-png.flaticon.com/128/733/733609.png",
    name: "Git",
  },
  {
    img: "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original.svg",
    name: "mongoDB",
  },

  {
    img: "https://camo.githubusercontent.com/93b32389bf746009ca2370de7fe06c3b5146f4c99d99df65994f9ced0ba41685/68747470733a2f2f7777772e766563746f726c6f676f2e7a6f6e652f6c6f676f732f676574706f73746d616e2f676574706f73746d616e2d69636f6e2e737667",
    name: "Postman",
  },
];
